import { DateTime } from "luxon"
import GroupTag from "packs/models/GroupTag"

export default class AutoCreateRoomRule {
    constructor(
        public id: string,
        public is_active: boolean,
        public copy_pub_room_public_id: string,
        public copy_pub_room_title: string,
        public astag_owner_open_schedule_title: string,
        public guest_open_schedule_title: string,
        public is_send_astag_owner: boolean,
        public create_plan_type: string,
        public group_tags: GroupTag[],
        public room_setting_id: string,
        public systemUpdatedAt: number
    ) {}

    static fetchFromJson(rulesJson: any[]): AutoCreateRoomRule[] {
        let rules = []
        for (let _rule of rulesJson || []) {
            let rule: AutoCreateRoomRule = _rule
            rules.push(rule)
        }
        return rules
    }

    static createDefault(defName = null): AutoCreateRoomRule {
        let now = DateTime.local()
        let rule = new AutoCreateRoomRule(
            null,
            true,
            null, // this.getSubject(defName),
            `<<出席者-1-氏名>>様の調整ページ`, // this.getContent(defName),
            `<<出席者-1-氏名>>様(<<出席者-1-所属名>>)との調整`,
            `<<調整カレンダー-オーナー名>>様(<<調整カレンダー-オーナー所属名>>)`,
            false,
            "copy_public_room_with_astag",
            [],
            null,
            now.toMillis()
        )
        return rule
    }

    static copy(o: AutoCreateRoomRule): AutoCreateRoomRule {
        let clone = Object.assign(Object.create(Object.getPrototypeOf(o)), o)
        return clone
    }

    static isSame(mf1: AutoCreateRoomRule, mf2: AutoCreateRoomRule): boolean {
        if (!mf1 || !mf2) return false
        return mf1.id == mf2.id && mf1.systemUpdatedAt == mf2.systemUpdatedAt
    }
}
